import { gql } from '@apollo/client';

//returns an address
export const PERSON_VEHICLE_HISTORY = gql`
  query personVehicleHistory($personId: ID!, $originatorId: ID!){
    personVehicleHistory(personId: $personId, originatorId: $originatorId) {
      id
      vehicleMake {
        id
        nhtsaId
        name
      }
      vehicleModel {
        id
        nhtsaId
        name
      }
      vehiclePlate {
        id
        name
      }
      vehicleState {
        id
        name
      }
      vehicleVin {
        id
        name
      }
      year
    }
  }
`;